import { endOfDay, isAfter, isBefore, startOfDay } from 'date-fns';

import dayjs, { type Dayjs } from 'dayjs';

export type DatePickerDateType = Dayjs;

export type PanelMode = 'date' | 'decade' | 'month' | 'quarter' | 'time' | 'week' | 'year';

export type RangePickerDateType<FirstDateType = DatePickerDateType, SecondDateType = FirstDateType> = RangeType<
  FirstDateType,
  SecondDateType
>;

export type RangeType<FirstDateType = Date, SecondDateType = FirstDateType> = [FirstDateType, SecondDateType];

export type TimePickerDateType = DatePickerDateType;

export function getDatePickerDateType(value: Date): DatePickerDateType;
export function getDatePickerDateType(value?: Date): DatePickerDateType | undefined;
export function getDatePickerDateType(value: Date | null): DatePickerDateType | null;
export function getDatePickerDateType(value?: Date | null): DatePickerDateType | null | undefined;
export function getDatePickerDateType(value?: Date | null): DatePickerDateType | null | undefined {
  return value ? dayjs(value) : value;
}

export function getDateType(value: DatePickerDateType): Date;
export function getDateType(value?: DatePickerDateType): Date | undefined;
export function getDateType(value: DatePickerDateType | null): Date | null;
export function getDateType(value?: DatePickerDateType | null): Date | null | undefined;
export function getDateType(value?: DatePickerDateType | null): Date | null | undefined {
  return value ? value.toDate() : value;
}

export const getTimePickerDateType = (value: Date): TimePickerDateType => getDatePickerDateType(value);

export const getTimeType = (value: TimePickerDateType): Date => getDateType(value);

export const disableFutureDates = (date: DatePickerDateType) => isAfter(getDateType(date), endOfDay(new Date()));

export const disablePastDates = (date: DatePickerDateType) => isBefore(getDateType(date), startOfDay(new Date()));

export const transformDateToDatePickerDateType = (value?: RangeType): RangePickerDateType | undefined =>
  value ? [getDatePickerDateType(value[0]), getDatePickerDateType(value[1])] : undefined;

export const transformDatePickerDateTypeToDate = (value?: RangePickerDateType): RangeType | undefined =>
  value ? [getDateType(value[0]), getDateType(value[1])] : undefined;

export const getDefaultValueFromRangePickerEvent = (value?: RangePickerDateType): RangePickerDateType | undefined =>
  value
    ? [
        getDatePickerDateType(startOfDay<Date, Date>(getDateType(value[0]))),
        getDatePickerDateType(endOfDay<Date, Date>(getDateType(value[1]))),
      ]
    : undefined;
